import { Component, Input } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { SharedService } from 'app/shared/services/shared.service';
import { HttpService } from 'app/shared/services/http.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'delete-network-component',
  templateUrl: './delete-network.component.html',
  styleUrls: ['./delete-network.component.scss'],
})
export class DeleteNetworkComponent {
  @Input() public data: any;
  public networkName: string;
  public isDeleting: boolean;
  public subscriptions: Array<any>;

  constructor(
    public httpService: HttpService,
    public dictionaryService: DictionaryService,
    public sharedService: SharedService,
    public modalsService: ModalsService,
    public ga: GoogleAnalyticsService
  ) {
    this.isDeleting = false;
    this.subscriptions = [];
  }

  ngOnDestroy() {}

  deleteNetwork() {
    this.isDeleting = true;
    this.subscriptions.push(
      this.httpService
        .post('networks_management/removeNetwork?networkId=' + this.data.networkId)
        .subscribe((response) => {
          this.sharedService.showFlashMessage(this.dictionaryService.get('NETWORK_DELETED_SUCCESSFULLY'), 'success');
          this.sharedService.sendMessage('NETWORK_UPDATED');
          this.modalsService.hideModal();
          this.isDeleting = false;
        })
    );
  }
}
